// components/redirects/ProductRedirect.jsx
import { Navigate, useParams } from "react-router-dom";

function ProductRedirect() {
  const { main_category_url, category_url, subcategory_url, product_url } =
    useParams();

  return (
    <Navigate
      to={`/${main_category_url}/${category_url}/${subcategory_url}/${product_url}`}
      replace
    />
  );
}

export default ProductRedirect;
